import { actionCreator } from '@ardoq/rxbeach';
import { PresentationChoice, PresentationPickerRequest } from './types';

export const openPresentationPicker = actionCreator<PresentationPickerRequest>(
  '[presentationPicker] OPEN'
);

export const closePresentationPicker = actionCreator<PresentationPickerRequest>(
  '[presentationPicker] CLOSE'
);

export const presentationPicked = actionCreator<{
  request: PresentationPickerRequest;
  choice: PresentationChoice;
}>('[presentationPicker] PRESENTATION_PICKED');
